export default __webpack_public_path__ + "static/media/canada-life-logo.8e048fc6.png";